/**
 * Returns ISO 4217 minor-unit digits via Intl. Fail-closed: throws on empty/invalid.
 */
export function getCurrencyMinorUnit(isoCode: string): number {
  const code = isoCode?.trim().toUpperCase();
  if (!code || code.length !== 3) {
    throw new Error(`Invalid currency ISO code: ${isoCode}`);
  }
  try {
    const digits = new Intl.NumberFormat('en', {
      style: 'currency',
      currency: code,
    }).resolvedOptions().maximumFractionDigits;
    if (digits == null || Number.isNaN(digits)) {
      throw new Error(`Unable to resolve minor unit for currency: ${code}`);
    }
    return digits;
  } catch (error) {
    if (error instanceof Error && error.message.startsWith('Invalid currency')) {
      throw error;
    }
    throw new Error(`Invalid currency ISO code: ${code}`);
  }
}
